import { useState, useCallback } from 'react';
import { j214Api } from '../../../services/j214Api';

export function useJ214Navigation(onNavigate: (id: string) => Promise<void>) {
  const [allIds, setAllIds] = useState<string[]>([]);
  const [currentIdx, setCurrentIdx] = useState(-1);

  const loadList = useCallback(async (): Promise<string[]> => {
    const res = await j214Api.list(1, 10000);
    const ids = (res.data || []).map(r => r.fj510_01).filter(Boolean);
    setAllIds(ids);
    return ids;
  }, []);

  const navTo = useCallback(async (idx: number, isEditing: boolean) => {
    if (idx < 0 || idx >= allIds.length || isEditing) return;
    setCurrentIdx(idx);
    await onNavigate(allIds[idx]);
  }, [allIds, onNavigate]);

  return {
    allIds, currentIdx,
    setAllIds, setCurrentIdx,
    loadList, navTo,
  };
}
